// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SnI6","textarea":"styles_textarea__PwMQz"};